import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

type Props = { reason?: 'human_agent' };

/** Empty state shown when no turn is selected or the turn carries no details. */
export const NoDetailsPanel = ({ reason }: Props) => {
  const { t } = useTranslation();

  const title = t('try_it.empty_turns_title');
  const description =
    reason === 'human_agent'
      ? t('try_it.empty_turns_subtitle_human_agent')
      : t('try_it.empty_turns_subtitle');

  return (
    <Empty className="justify-start px-0 py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <InfoIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
